






















import {defineComponent} from "@vue/composition-api";
import LoadingBlock from "@base/Components/LoadingBlock.vue";

export default defineComponent({
    components: {
        LoadingBlock
    },

    props: {
        title: {
            type: String,
            required: true
        },
        redirecting: {
            type: Boolean,
            default: false
        }
    },
})
